import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICertificate } from "../certificateSlice";

export const getAllCertificate = createAsyncThunk("Certificates/FindAllCertificates", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Certificates/FindAllCertificates`,
      {
        Certificate: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Certificate:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createCertificate = createAsyncThunk(
  "Certificates/InsertCertificates",
  async (CertificateData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Certificates/InsertCertificates`,
        CertificateData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCertificate = createAsyncThunk(
  "Certificates/UpdateCertificates",
  async (CertificateData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Certificates/UpdateCertificates`,
        CertificateData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCertificate = createAsyncThunk(
  "Certificates/DeleteCertificates",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Certificates/DeleteCertificates`,
        {
          ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCertificateByID = createAsyncThunk(
  "Certificates/FindByIDCertificates",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Certificates/FindByIDCertificates`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Name: result.Name,
        Image: result.Image,
        IsActive: result.IsActive ? 1 : 2,
      } as ICertificate;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCertificate = createAsyncThunk(
  "Certificates/FindAllActiveCertificates",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Certificates/FindAllActiveCertificates`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificatees:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveCertificate = createAsyncThunk(
  "Certificates/ActiveInActiveCertificates",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Certificates/ActiveInActiveCertificates`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);


export const updateCertificateImage = createAsyncThunk(
  "Certificates/CertificatesImageUpdate",
  async (ClientLogoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Certificates/CertificatesImageUpdate`,
        ClientLogoData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating client logo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);